import React, { useEffect, useRef, useState } from 'react';
import { usePopper } from 'react-popper';
import styled, { css, keyframes } from 'styled-components';
import { IconActionMore } from '@cko/icons';
import { Flex, Box, ClickableElement } from '@cko/primitives';
import { Portal } from '../Portal';
const Container = styled(Flex) `
  position: relative;
  width: var(--layout-shoebox);
`;
const IconButton = styled(ClickableElement) `
  width: var(--layout-shoebox);
  height: var(--layout-shoebox);
  border-radius: 50%;
  transition: all 0.2s ease-in-out;
  background: ${({ isActive }) => (isActive ? 'var(--control-bg-good-decorative)' : 'transparent')};
  pointer-events: ${({ isFeaturePromotion }) => (isFeaturePromotion ? 'none' : 'auto')};
  border: ${({ isFeaturePromotion }) => isFeaturePromotion ? 'var(--border-b-soybean) dashed var(--base-icon-good)' : 'none'};

  svg > g {
    fill: var(--action-bg-selected);
  }

  &:focus:not(:focus-visible) {
    outline: none;
  }

  &:hover {
    background: var(--control-bg-good-decorative);

    svg > g {
      fill: var(--action-bg-selected);
    }
  }
`;
const ContextMenuContainer = styled(Box) `
  position: absolute;
  right: 0;
  top: var(--layout-saxophone);
  padding: var(--layout-shoe) 0;
  border: var(--border-b-seed) solid var(--base-border-secondary);
  box-shadow: var(--control-e-shoe);
  z-index: 1;

  ${({ isVisible }) => isVisible
    ? css `
          visibility: visible;
          height: auto;
          overflow: visible;
          min-width: 280px;
        `
    : css `
          visibility: hidden;
          pointer-events: none;
          overflow: hidden;
          height: 0;
          width: 0;
        `}
`;
const tooltipAnimation = keyframes `
 0% { opacity: 0 }
 100% {opacity: 1 }
`;
const PromotionTooltipWrapper = styled(Box) `
  animation: ${tooltipAnimation} 0.5s linear;
`;
export const EllipsesButtonMenu = (props) => {
    const contextMenuRef = useRef(null);
    const ellipsesButtonRef = useRef(null);
    const [referenceElement, setReferenceElement] = useState(null);
    const [popperElement, setPopperElement] = useState(null);
    const { styles, attributes } = usePopper(referenceElement, popperElement, {
        placement: 'bottom',
        modifiers: [
            {
                name: 'offset',
                options: {
                    offset: [20, -35],
                },
            },
        ],
    });
    const { children, id, testId = 'ellipses-context-menu-button', isVisible = false, toggleMenu, analyticsId = 'context-menu-button', isFeaturePromotion = false, promotionTooltip, } = props;
    const handleClickOutside = (e) => {
        if (isVisible &&
            contextMenuRef.current &&
            !contextMenuRef.current?.contains(e.target) &&
            ellipsesButtonRef.current &&
            !ellipsesButtonRef.current?.contains(e.target)) {
            toggleMenu();
        }
    };
    useEffect(() => {
        if (isVisible) {
            document.addEventListener('mousedown', handleClickOutside);
        }
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    });
    return (React.createElement(Container, { ref: setReferenceElement },
        React.createElement(IconButton, { isActive: isVisible, type: "button", onClick: toggleMenu, "data-testid": testId, id: id, "data-analytics-id": analyticsId, ref: ellipsesButtonRef, isFeaturePromotion: isFeaturePromotion },
            React.createElement(IconActionMore, null)),
        isFeaturePromotion && React.createElement(PromotionTooltipWrapper, null, promotionTooltip),
        isVisible && (React.createElement(Portal, null,
            React.createElement(Box, { ref: setPopperElement, style: { ...styles.popper, zIndex: 1 }, ...attributes.popper },
                React.createElement(ContextMenuContainer, { backgroundColor: "white", borderRadius: "var(--layout-stamp)", isVisible: isVisible, "data-testid": "ellipses-context-menu", ref: contextMenuRef }, children))))));
};
